export default "__VITE_ASSET__BmOhZJE2__"